<template>
  <div class="flex flex-col md:flex-row gap-4">
    <div class="w-full md:w-1/6">
      <div class="flex flex-col space-y-5 items-center font-niceone-medium">
        <p class="text-primary text-5xl">{{ averageReviews }}</p>
        <van-rate
            v-model="averageReviews"
            allow-half
            color="#997adb"
            readonly
            size="25"
            void-color="#eee"
            void-icon="star"
        />
        <p class="text-grey-muted text-xs">
          {{ $t('product.reviews.based_on_reviews', {review_total: reviewsData?.review_total}) }}</p>
      </div>
    </div>
    <div class="w-full md:w-5/6">
      <div class="flex justify-between items-center">
        <select-field v-model="sortModel" :block="false" :options="sortOptionsReview"
                      :placeholder="$t('product.reviews.please_select_option')"/>
        <van-button v-if="!reviewsData?.is_review"
                    class="!bg-secondary-light !text-secondary font-bold !border-none"
                    @click="addReview">
          {{ $t('product.reviews.add_review') }}
        </van-button>
      </div>
      <ul class="flex flex-col !p-0">
        <review-list-item v-for="(review,index) in reviews" :key="`review-${index}`" :index="index" :product="product"
                          :review="review"/>
      </ul>
      <load-more-btn v-if="isLoadMore" v-model="pageModel" :loading="loading" class="pt-2"
                     @change="emit('getReviews')"/>
    </div>
    <review-model v-model="showReviewModal" :product="product"/>
  </div>
</template>

<script setup>
import {useAuthStore} from "~/store/auth";
import ReviewModel from "@/components/product/ReviewModal";
import LoadMoreBtn from "@/components/common/LoadMoreBtn";
import SelectField from "@/components/form/SelectField";
import ReviewListItem from "@/components/product/reviews/ReviewListItem";
import {useEventBus} from "@vueuse/core";
import {EVENTS, TRACKERS} from "~/constants/events";
import {track} from "~/composables/useTrackEvent";

const {t} = useI18n()
const props = defineProps({
  reviews: {
    type: Array,
    default: () => []
  },
  reviewsData: {
    type: Object,
    default: () => {
    }
  },
  product: {
    type: Object,
    default: () => {
    }
  },
  sort: {
    type: String,
    default: ""
  },
  page: {
    type: [Number, String],
    default: 1
  },
  loading: {
    type: Boolean,
    default: false
  },
  isLoadMore: {
    type: Boolean,
    default: true
  }
})
const authStore = useAuthStore();
const {isLoggedIn} = storeToRefs(authStore);
const emit = defineEmits(['update:sort', 'update:page', 'getReviews']);
const {emit: emitAuth} = useEventBus(EVENTS.AUTH_DIALOG);
const sortOptionsReview = ref([
  {
    name: t('product.reviews.recently_added_first'),
    value: 'desc'
  },
  {
    name: t('product.reviews.highest_rating_first'),
    value: 'desc_rating'
  }
])
const showReviewModal = ref(false);
const comments = ref([]);

const averageReviews = computed(() => parseFloat(Math.floor(props.reviewsData?.average * 10) / 10) || 0)

const sortModel = computed({
  get() {
    return props.sort
  },
  set(val) {
    emit('update:sort', val)
  }
})

const pageModel = computed({
  get() {
    return props.page
  },
  set(val) {
    emit('update:page', val)
  }
})

const addReview = () => {
  if (isLoggedIn.value)
    showReviewModal.value = true
  else
    emitAuth({redirection: false})
}

watch(sortModel, (sort) => {
  track(TRACKERS.REVIEW_SORT, {eventLabel: sort, product: props.product})
});
</script>

<style lang="scss" scoped>

</style>